import axiosClient from '../libs/axios'

export const getProfile = async () => {
  const response = await axiosClient.get('/profile')
  return response.data
}

export const updateGeneral = async ({ ufname, ulname, uwork }) => {
  const response = await axiosClient.post('/profile/general', { ufname, ulname, uwork })
  return response.data
}

export const uploadAvatar = async (file) => {
  const form = new FormData()
  form.append('file', file)
  const response = await axiosClient.post('/profile/avatar', form, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
  return response.data
}

export const uploadImage = async (file, extra = {}) => {
  const form = new FormData()
  form.append('file', file)
  Object.entries(extra || {}).forEach(([key, value]) => {
    if (value !== undefined && value !== null) form.append(key, value)
  })
  const response = await axiosClient.post('/profile/upload', form, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
  return response.data
}
